import React from 'react';

export const AppSchedulerList = () => {
  return (
    <div>
      <h1>App Scheduler List</h1>
      <p>...</p>
    </div>
  );
}